export default {
  mapping: [
    {
      companyCode: 'CN1688117055706',
      appCode: 'co.doctoratoz.puhealth',
      domainName: 'drpuhealth.doctoratoz.co',
      companyName: 'กรมอนามัย'
    },
    {
      companyCode: 'CN1691739003644',
      appCode: 'co.doctoratoz.bkkgi',
      domainName: 'dr.healthtalkth.com',
      companyName: 'BkkGi'
    },
    {
      companyCode: 'CN1610705529244',
      appCode: 'co.doctoratoz.chularat',
      domainName: 'drchg.doctoratoz.co',
      companyName: 'CHG Company'
    },
    {
      companyCode: 'CN1658466861097',
      appCode: 'co.doctoratoz.wtcare',
      domainName: 'drwt.doctoratoz.co',
      companyName: 'วังทอง'
    },
    {
      companyCode: 'CN1699870778015',
      appCode: 'co.doctoratoz.suphan',
      domainName: 'drsuphan.doctoratoz.co',
      companyName: 'อบจ.สุพรรณบุรี'
    },
    {
      companyCode: 'CN1621321597697',
      appCode: 'co.doctoratoz.chiva',
      domainName: 'drchiva.doctoratoz.co',
      companyName: 'CHIVA HISxHER'
    },
    {
      companyCode: 'CN1600835175233',
      appCode: 'co.doctoratoz.mmt',
      domainName: 'drmmt.doctoratoz.co',
      companyName: 'มิตรไมตรีคลินิก (mmt)'
    },
    {
      companyCode: 'CN1660883798367',
      appCode: 'co.doctoratoz.chersery',
      domainName: 'drch.doctoratoz.co',
      companyName: 'เฌ้อเซอรี่ โฮม'
    }
  ]
};
